import {
    AfterContentChecked,
    AfterContentInit, AfterViewInit, Component, ContentChild, ElementRef, Input, OnInit, Renderer2,
    ViewChild
} from '@angular/core';
import { Store } from '@ngrx/store';

import { genericStringValidator, ValidationMessages } from '../../../utils/util-functions';
import { CartGroup, isProductGroup } from '../../../model/cart.model';
import * as fromApp from '../../../store/app.reducers';
import * as CartActions from '../../../store/cart/cart.actions';
import { unescape as htmlDecode } from 'lodash';

@Component({
    selector: 'app-cart-manage-sampling',
    templateUrl: './cart-manage-sampling.component.html',
    styleUrls: ['./cart-manage-sampling.component.scss']
})
export class CartManageSamplingComponent implements OnInit  {
    @Input() group: CartGroup;
    @Input() readonly = false;

    @ViewChild('nameInput', { static: false })
        nameInput: ElementRef;

    error = '';
    editMode = false;
    labelName: string;
    menuVisible = false;
    documentClickListener: any;
    preventDocumentDefault: any;
    groupType = false;

    constructor(private store: Store<fromApp.AppState>,
        public renderer: Renderer2) {
    }

    ngOnInit() {
        this.documentClickListener = this.renderer.listen('document', 'click', () => {
            if (!this.preventDocumentDefault) {
                this.menuVisible = false;
            }
            this.preventDocumentDefault = false;
        });
        const originalError = this.group.groupNameError;
        if (originalError != null) {
            this.updateErrorMessage(originalError.errorMessage);
            this.labelName = originalError.userInputGroupName;
        } else {
            this.labelName = this.group.name;
        }

        this.labelName = htmlDecode(this.labelName);
        this.groupType = isProductGroup(this.group.resourceType);
        this.editMode = !!this.error;
    }

    onEdit(event) {
        this.setEditMode(true);
        setTimeout(() => this.nameInput.nativeElement.select());
    }

    updateGroupName() {
        const validationMessage = genericStringValidator(this.labelName);

        if (validationMessage === ValidationMessages.INVALID) {
            this.error = 'Please provide a valid name';
            return;
        } else if (validationMessage === ValidationMessages.NON_LATIN) {
            this.error = 'Only latin characters are allowed';
            return;
        } else if (validationMessage === ValidationMessages.EXCEEDS_MAX_LENGTH) {
            this.error = 'Maximum ' + ValidationMessages.MAXIMUM_LENGTH + ' characters are allowed';
            return;
        } else if (this.group.name !== this.labelName) {
            this.store.dispatch(new CartActions.UpdateSampleName(this.group.id, this.labelName));
        }
        this.clearErrorMessageInCart();
        this.setEditMode(false);
    }

    deleteCartGroup() {
        this.store.dispatch(new CartActions.DeleteCartGroup(this.group.id));
    }

    cancelEditing() {
        this.labelName = this.group.name;
        this.clearErrorMessageInCart();
        this.setEditMode(false);
    }

    clearErrorMessageInCart() {
        this.store.dispatch(new CartActions.SetGroupErrorMessage(null, this.group.id, null));
    }

    setEditMode(flag: boolean) {
        this.editMode = flag;
    }

    toggleMenu() {
        this.menuVisible = !this.menuVisible;
        this.preventDocumentDefault = true;
    }

    updateErrorMessage(originalErrorMessage: string) {
        if (originalErrorMessage === null || originalErrorMessage === undefined) {
            return;
        }

        const editNameProductGroupExpectedErrorMessage = 'editing group name not supported for non service group.';

        if (!originalErrorMessage.endsWith('exists')) {
        } else {
            this.error = 'Name already exists';
        }
        if (originalErrorMessage.startsWith(editNameProductGroupExpectedErrorMessage)) {
            this.error = 'sampling supplies name cannot be edited';
        }
    }
}
